/* VAT info toggletip beside the PDP price (snippets/ergo-vat-info.liquid).
   Delegated, because the price markup is re-rendered on variant change. */
(function () {
  var closeTimer = null;
  var canHover = window.matchMedia('(hover: hover)').matches;

  function setOpen(root, open) {
    root.classList.toggle('is-open', open);
    var btn = root.querySelector('.ergo-vat-info__btn');
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function closeAll(except) {
    document.querySelectorAll('[data-ergo-vat-info].is-open').forEach(function (root) {
      if (root !== except) setOpen(root, false);
    });
  }

  // The whole "No VAT charged" note is the tap target, not just the icon.
  document.addEventListener('click', function (event) {
    if (event.target.closest('.ergo-vat-info__panel')) return;
    var note = event.target.closest('.ergo-price-note');
    var root = note ? note.querySelector('[data-ergo-vat-info]') : null;
    if (!root) return closeAll();
    event.preventDefault();
    closeAll(root);
    // With a mouse the panel is already open from hover, so a click must not close it.
    setOpen(root, canHover ? true : !root.classList.contains('is-open'));
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeAll();
  });

  document.addEventListener('focusout', function (event) {
    var root = event.target.closest('[data-ergo-vat-info]');
    if (root && !root.contains(event.relatedTarget) && !root.matches(':hover')) setOpen(root, false);
  });

  // Hover only where a real pointer exists, so taps are not double-handled.
  if (!canHover) return;

  document.addEventListener('mouseover', function (event) {
    var root = event.target.closest('[data-ergo-vat-info]');
    if (!root) return;
    clearTimeout(closeTimer);
    closeAll(root);
    setOpen(root, true);
  });

  document.addEventListener('mouseout', function (event) {
    var root = event.target.closest('[data-ergo-vat-info]');
    if (!root || root.contains(event.relatedTarget)) return;
    closeTimer = setTimeout(function () {
      if (!root.contains(document.activeElement)) setOpen(root, false);
    }, 250);
  });
})();
